import AgoraLiveCore from "../core/mediaCore/agoreSdk"
import MbsCoreSdk from "../core/mediaCore/MbsCoreSdk"
// import { vendorTypes } from "../util/interface"
import { AGORA_VENDOR, MBS_VENDOR } from "../util/eventTypes"
export const getVendorCore = types => {
  if (types === AGORA_VENDOR) {
    return AgoraLiveCore
  } else if (types === MBS_VENDOR) {
    return MbsCoreSdk
  }
  // else if (vendorTypes[types] === "vls") {
  //   return VlsCore;
  // }
}
